import React, { useEffect } from 'react'
import styled from 'styled-components'
import { withNamespaces } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import Select from 'react-select'

import logoInternational from '../images/logo_EN.png'
import logoRuServer from '../images/logo_RU.png'
import userIcon from '../images/user_icon.png'
import homeIcon from '../images/home_icon.png'
import webexIcon from '../images/webex.png'
import interactionsIcon from '../images/touch_app_icon.png'
import contractIcon from '../images/receipt_icon.png'
import {getIsRuServer} from "../helpers/getIsRuServer";

const StyledNavbarContainer = styled.div`
  margin: 0 auto;
  height: 76px;
  max-width: 1110px;

  position: relative;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`

const StyledLogo = styled.div`
  width: ${getIsRuServer() ? 78 : 137}px;
  height: 30px;
  background: url(${getIsRuServer() ? logoRuServer : logoInternational}) no-repeat center center;
  background-size: 100% 100%;

  @media (max-width: 1132px) {
    margin-left: 18px;
    margin-right: 10px;
  }
`

const StyledMenuList = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`

const StyledMenuItem = styled.div`
  a {
    display: flex;
    align-items: flex-end;
    color: #727272;

    transition: all 0.2s;

    :hover {
      text-decoration: none;
    }
  }

  margin-right: 30px;

  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: bold;

  color: ${(props) => (props.active ? '#4C84FF' : '#727272')};

  &:hover {
    color: #4c84ff;
    text-decoration: none;
  }

  .icon {
    width: 20px;
    height: 20px;
    background: url(${(props) => props.icon}) no-repeat center center;
    background-size: contain;
    margin-right: 10px;
    margin-bottom: 0px;
  }

  @media (max-width: 992px) {
    margin-right: 20px;
  }
`

const StyledDivider = styled.div`
  width: 1px;
  height: 100%;
  background-color: #f1f2f3;
  margin: 0 18px;
`

const StyledUserControl = styled.div`
  min-width: 38px;
  height: 38px;
  background: url(${userIcon}) no-repeat center center;
  background-size: 100% 100%;
  margin-right: 18px;

  position: relative;
  cursor: pointer;
`

const StyledMenuWrapper = styled.div`
  position: absolute;
  width: 200px;
  height: auto;
  top: calc(100% + 19px);
  right: -19px;

  z-index: 1000;
  display: flex;
  justify-content: flex-end;
`

const StyledMenu = styled.div`
  display: flex;
  flex-direction: column;

  box-shadow: 0 0 11px 0px rgba(0, 0, 0, 0.1);

  border-radius: 4px;
  padding: 20px;

  background-color: #fff;
`

const StyledLanguageSelect = styled.div`
  display: flex;
  flex-direction: column;
  color: #727272;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;

  .title {
    color: #2f2d2d;
    text-transform: uppercase;
    letter-spacing: 1.12px;
    padding-bottom: 5px;
    text-align: center;
  }

  .language {
    text-align: center;

    &.active {
      color: blue;
    }

    cursor: pointer;
  }
`

const StyledPasswordButton = styled.div`
  margin: 10px 0 0;
  text-align: center;

  color: #727272;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;

  cursor: pointer;
`

const StyledLogoutButton = styled.div`
  margin: 10px 0;
  text-align: center;

  color: #727272;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;

  cursor: pointer;
`

const StyledPropertySelectWrapper = styled.div`
  position: relative;
  width: 200px;
  z-index: 999;

  border: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  background-color: #fff;

  .test {
    border: none;
  }
`

const StyledPropertyName = styled.div`
  width: 200px;
  color: #727272;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

const StyledPropertySelector = styled.select`
  position: relative;
  width: 140px;

  border: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  background-color: #fff;
`

const StyledEllipsisLink = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

const onSelectValueChanged = (callback) => ({ value }) => {
  callback({ target: { value } })
}

const renderPropertySelector = ({
  properties,
  t,
  propertyChangeHandlers,
  location
}) => {
  const { entities, selectedPropertyId } = properties

  let isContractPage = false

  let propertyHandler
  if (location.pathname.indexOf('/dashboard/main') !== -1) {
    propertyHandler = propertyChangeHandlers.handlePropertyMainChange
  } else if (location.pathname.indexOf('/dashboard/interaction') !== -1) {
    propertyHandler = propertyChangeHandlers.handlePropertyInteractionsChange
  } else if (location.pathname.indexOf('/dashboard/contracts') !== -1) {
    isContractPage = true
    propertyHandler = propertyChangeHandlers.handlePropertyContractsChange
  } else {
    propertyHandler = () => {}
  }

  let options = entities.map(({ property_id, name }) => ({
    value: property_id,
    label: name
  }))

  if (!isContractPage) {
    options = [
      {
        value: '',
        label: t('property:allProperties')
      },
      ...options
    ]
  }

  const selectValue = options.find((o) => o.value === selectedPropertyId)

  if (entities.length === 1 && selectValue && selectValue.label) {
    return <StyledPropertyName>{selectValue.label}</StyledPropertyName>
  }

  return (
    <StyledPropertySelectWrapper>
      <Select
        value={selectValue}
        options={options}
        className="header_select"
        onChange={onSelectValueChanged(propertyHandler)}
      />
    </StyledPropertySelectWrapper>
  )

  return (
    <StyledPropertySelector
      value={selectedPropertyId}
      onChange={propertyHandler}
    >
      {!isContractPage && (
        <option value={''}>{t('property:allProperties')}</option>
      )}
      {entities.map(({ property_id, name }) => {
        return (
          <option key={property_id} value={property_id}>
            {name}
          </option>
        )
      })}
    </StyledPropertySelector>
  )
}

const DesktopNavbar = ({
  properties,
  t,
  toggle,
  changeLanguage,
  lang,
  logout,
  isOpen,
  propertyChangeHandlers,
  location,
  history,
  languages,
  sendInfoToJivoChat
}) => {
  useEffect(() => {
    sendInfoToJivoChat()
  }, [location.pathname])

  return (
    <StyledNavbarContainer>
      <StyledLogo />
      <StyledMenuList>
        <StyledMenuItem icon={homeIcon}>
          <NavLink
            activeStyle={{
              color: '#4c84ff'
            }}
            activeClassName="active"
            to="/dashboard/main"
          >
            <div className="icon" />
            <StyledEllipsisLink>{t('navigation:main')}</StyledEllipsisLink>
          </NavLink>
        </StyledMenuItem>
        <StyledMenuItem icon={interactionsIcon}>
          <NavLink
            activeStyle={{
              color: '#4c84ff'
            }}
            activeClassName="active"
            to="/dashboard/interactions"
          >
            <div className="icon" />
            <StyledEllipsisLink>
              {t('navigation:interactions')}
            </StyledEllipsisLink>
          </NavLink>
        </StyledMenuItem>
        <StyledMenuItem icon={contractIcon}>
          <NavLink
            activeStyle={{
              color: '#4c84ff'
            }}
            activeClassName="active"
            to="/dashboard/contracts"
          >
            <div className="icon" />
            <StyledEllipsisLink>{t('navigation:contracts')}</StyledEllipsisLink>
          </NavLink>
        </StyledMenuItem>
        <StyledMenuItem icon={webexIcon}>
          <a
            href={
              'https://hrsintl1.webex.com/mw3300/mywebex/default.do?siteurl=hrsintl1&service=9'
            }
            target="_blank"
          >
            <div className="icon" />
            <StyledEllipsisLink>WEBEX</StyledEllipsisLink>
          </a>
        </StyledMenuItem>
      </StyledMenuList>
      <StyledDivider />
      {renderPropertySelector({
        properties,
        t,
        location,
        propertyChangeHandlers
      })}
      <StyledDivider />
      <StyledUserControl onClick={toggle}>
        {isOpen && (
          <StyledMenuWrapper>
            <StyledMenu>
              <StyledLanguageSelect>
                <div className="title">Language</div>
                {Object.entries(languages).map(([value, name]) => (
                  <div
                    key={value}
                    onClick={() => {
                      changeLanguage(value)
                      toggle()
                    }}
                    className={`language ${lang === value && 'active'}`}
                  >
                    {name}
                  </div>
                ))}
              </StyledLanguageSelect>
              <StyledPasswordButton
                onClick={() => {
                  history.push('/change-password')
                }}
              >
                {t('forms:updatePassword')}
              </StyledPasswordButton>
              <StyledLogoutButton
                onClick={() => {
                  toggle()
                  logout()
                }}
              >
                {t('navigation:signOut')}
              </StyledLogoutButton>
            </StyledMenu>
          </StyledMenuWrapper>
        )}
      </StyledUserControl>
    </StyledNavbarContainer>
  )
}

export default withRouter(withNamespaces()(DesktopNavbar))
